import { JsonObject, JsonProperty } from 'json2typescript';

import { LearnCertClass } from '../../model/learn-cert/learn-cert-class';
import { LearnCert } from '../../model/learn-cert/learn-cert';
import { LearnCertDisableConfig } from '../../model/learn-cert/learn-cert-disable-config/learn-cert-disable-config';
import { isUndefined } from 'util';

@JsonObject
export class LearnCertChosenResult extends LearnCert {

  @JsonProperty('hasLearnCert', Boolean, true)
  hasLearnCert = false;

  constructor(hasLearnCert?: boolean) {
    super();
    this.hasLearnCert = hasLearnCert;
  }

  deleteDisabledEntries(classes: LearnCertClass[], disableConfig: LearnCertDisableConfig) {
    classes = classes || [];
    this.resetEntriesByLearnCertClass(classes);
    this.entries = this.entries.filter(entry => {
      if (entry.learnCertType) {
        if (isUndefined(disableConfig)) {
          return entry.learnCertType.enabled;
        } else {
          return entry.learnCertType.enabled && !disableConfig.learnCertTypeIds.some(typeId => typeId === entry.typeId);
        }
      }
      return true;
    });
  }
}
